<app-topnav [llttfPage]="llttfPage"></app-topnav>

<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
      <div class="participant-banner" [ngClass]="participantClassByRole">
        <div class="container">
          <h2>{{'viewPlanText'|translate:translations}}</h2>
        </div>
      </div>
      <div class="h-30"></div>
      <div class="container">
        <div class="plan-goals-heading open-plan-header">
          <span><img src="assets/plan-goals.svg" class="plan-goal-thumbnail"></span>
          <span class="w-10p"></span>
          <div class="closed-plan-header-content-div">
            <h2>{{closedPlanView.planName}}</h2>
            <span class="plan-date-and-reminder-div">
              <span><img src="assets/calendar.svg" class="reminder-bell pr-3">{{ getScheduleLabel(closedPlanView.whenAreYouGoingToDoIt) }}</span>
              <span class="w-20p"></span>
              <span><img src="assets/reminder-bell.svg" class="reminder-bell pr-3"> {{ getScheduleLabel(closedPlanView.reminderFrequency) }}</span>
            </span>
          </div>
        </div>
        <div class="h-30"></div>
        <div class="closed-plan-form">
          <span class="question">{{'whatAreYouGoingToDoText'|translate:translations}}?</span>
          <span class="answer">{{closedPlanView.whatAreYouGoingToDo}}</span>
          <div class="mb-10"></div>
        </div>

        <div class="closed-plan-form">
          <span class="question"> {{'problemsText'|translate:translations}}?</span>
          <span class="answer">{{closedPlanView.difficultiesAndSolutions}}</span>
          <div class="mb-10"></div>
        </div>

        <div class="closed-plan-form">
          <span class="question"> {{'finalPlanText'|translate:translations}}</span>
          <span class="answer">{{closedPlanView.finalPlan}}</span>
          <div class="mb-10"></div>
        </div>

        <div class="h-30"></div>

        <div class="form-buttons">
          <button class="submit-form-button" [ngClass]="participantClassByRole" (click)="navigate('participants/plans/close-plan/'+closedPlanView.id)">{{'markPlanAsDoneText'|translate:translations}}</button>
          <button class="submit-form-button cancel-button" [ngClass]="participantClassByRole" (click)="navigate('participants/plans/edit-plan/'+closedPlanView.id)">{{'editPlanText'|translate:translations}}</button>
          <span class="delete-plan-link" (click)="deletePlan()">{{'deletePlanText'|translate:translations}}</span>
        </div>

      </div>
    </div>
  </div>
</div>
@if (modalOpen | async) {
  <app-modal [title]="modalTitle" [content]="modalContent" [okButtonValue]="modalOkButtonValue"
  [cancelButtonValue]="modalCancelButtonValue" [okButtonText]="modalOkButtonText" [cancelButtonText]="modalCancelButtonText"></app-modal>
}

<app-footer [bbapp]="true"></app-footer>
